import * as Scrivito from "scrivito";
import { isPlainObject } from "lodash-es";
import dataFromAuthor from "./SchemaDotOrg/dataFromAuthor";
import dataFromEvent from "./SchemaDotOrg/dataFromEvent";
import dataFromJob from "./SchemaDotOrg/dataFromJob";
import dataFromAddressWidget from "./SchemaDotOrg/dataFromAddressWidget";

const SchemaDotOrg = Scrivito.connect(({ content }) => {
  const data = pruneEmptyValues(dataFromItem(content));

  return <script type="application/ld+json">{JSON.stringify(data)}</script>;
});

// Returns true if the value is considered empty
// replace isEmpty from is-empty package to reduce bundle size
function isEmptyValue(v) {
  if (v == null) return true; // null or undefined
  if (typeof v === "string") return v.trim().length === 0;
  if (Array.isArray(v)) return v.length === 0;
  if (typeof v === "object") return Object.keys(v).length === 0;
  return false;
}

function dataFromItem(item) {
  switch (item.objClass()) {
    case "AddressWidget":
      return dataFromAddressWidget(item);
    case "Author":
      return dataFromAuthor(item);
    case "Event":
      return dataFromEvent(item);
    case "Job":
      return dataFromJob(item);
    default:
      throw new Error(
        `SchemaDotOrg for objClass ${item.objClass()} not supported!`
      );
  }
}

function pruneEmptyValues(data) {
  let prunedData = mapValues(data, (subData) => {
    if (isPlainObject(subData)) {
      return pruneEmptyValues(subData);
    }
    return subData;
  });

  prunedData = pickBy(prunedData, (v) => !isEmptyValue(v));

  const keysWithoutAt = Object.keys(prunedData).filter(
    (sd) => !sd.startsWith("@")
  );
  if (keysWithoutAt.length) {
    return prunedData;
  }
  return {};
}

function arrayToObject(array) {
  return Object.assign(...array.map(([key, value]) => ({ [key]: value })));
}

function mapValues(data, fn) {
  return arrayToObject(
    Object.entries(data).map(([key, value]) => [key, fn(value)])
  );
}

function pickBy(data, fn) {
  return arrayToObject(
    Object.entries(data).filter(([_key, value]) => fn(value))
  );
}

export default SchemaDotOrg;
